import { IChatbotPart } from './part';
import { IChatbotQuestion } from './question';

export enum ChatbotConversationType {
  MESSAGE = 'message',
  QUESTIONS = 'questions',
  PARTS_LIST = 'parts-list',
}

export enum ChatbotConversationDirection {
  INCOMING = 'incoming',
  OUTGOING = 'outgoing',
}

export interface IChatbotConversationBase {
  type: ChatbotConversationType;
  title?: string;
}

export interface IChatbotConversationMessage extends IChatbotConversationBase {
  type: typeof ChatbotConversationType.MESSAGE;
  direction?: ChatbotConversationDirection;
  message: string;
}

export interface IChatbotConversationQuestions extends IChatbotConversationBase {
  type: typeof ChatbotConversationType.QUESTIONS;
  questions: IChatbotQuestion[];
  onSubmit?: (questions: IChatbotQuestion[]) => void;
}

export interface IChatbotConversationPartsList extends IChatbotConversationBase {
  type: typeof ChatbotConversationType.PARTS_LIST;
  parts: IChatbotPart[];
  onUseThisBom?: (parts: IChatbotPart[]) => void;
}

export type IChatbotConversation =
  | IChatbotConversationMessage
  | IChatbotConversationQuestions
  | IChatbotConversationPartsList;
